import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import emailjs from "emailjs-com"; // Added

const LeadsFromShops = () => {
  const [shopCode, setShopCode] = useState("");
  const [smname, setSmname] = useState("");
  const [smmobile, setSmmobile] = useState("");
  const [smemail, setSmemail] = useState("");
  const [form, setForm] = useState({
    username: "",
    mobile: "",
    loanamount: "",
    loantype: "",
    email: "",
    employmentType: "salaried", // Added
    monthlySalary: "", // Added
    companyName: "", // Added
  });
  const [showSuccess, setShowSuccess] = useState(false); // Added

  useEffect(() => {
    // Read shopCode and SM details from URL query param
    const params = new URLSearchParams(window.location.search);
    setShopCode(params.get("shopCode") || "");
    setSmname(params.get("smname") || "");
    setSmmobile(params.get("smmobile") || "");
    setSmemail(params.get("smemail") || "");
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleEmploymentTypeChange = (e) => {
    setForm({ ...form, employmentType: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const now = new Date();
    const createdDate = now.toISOString().slice(0, 10);
    const createdTime = now.toTimeString().slice(0, 8);

    const data = {
      shopCode,
      name: form.username,
      mobile: form.mobile,
      loanAmount: form.loanamount,
      loanType: form.loantype,
      email: form.email,
      employmentType: form.employmentType,
      monthlySalary: form.monthlySalary,
      companyName: form.companyName,
      createdDate,
      createdTime,
      loanStatus: "Pending",
    };

    try {
      await axios.post(
        "https://api.dremerz.net/api/DZ_8921_Mybankshoppy_Save_QR_LeadFromShops",
        data
      );

      // Send email to SM using emailjs
      const emailParams = {
        smname,
        smmobile,
        smemail,
        shopCode,
        name: form.username,
        mobile: form.mobile,
        loanAmount: form.loanamount,
        loanType: form.loantype,
        email: form.email,
        employmentType: form.employmentType,
        monthlySalary: form.monthlySalary,
        companyName: form.companyName,
        createdDate,
        createdTime,
      };

      // Replace with your actual EmailJS service, template, and public key
      await emailjs.send(
        "service_zontr6e",
        "template_c7nv8li",
        emailParams,
        "aJnP5PotDQdflEJWg"
      );

      setShowSuccess(true); // Show popup
      setForm({
        username: "",
        mobile: "",
        loanamount: "",
        loantype: "",
        email: "",
        employmentType: "salaried",
        monthlySalary: "",
        companyName: "",
      });
    } catch {
      alert("Failed to submit lead");
    }
  };

  return (
    <div
      className="container mt-4"
      style={{
        width: "100%",
        maxWidth: 400,
        padding: "0 8px",
      }}
    >
      {/* Add viewport meta tag for mobile zoom fix */}
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
      />
      {/* Stepper-style sub-navbar */}

      <h3 className="mb-4" style={{ fontSize: "1.3rem" }}>
        Apply for Loan
      </h3>
      {/* {shopCode && (
        <div className="mb-3">
          <strong>Shop Code:</strong> {shopCode}
        </div>
      )} */}
      {/* Optionally show SM details */}
      {/* {(smname || smmobile || smemail) && (
        <div className="mb-3">
          <strong>Shop Code:</strong> {shopCode} <br />
          <strong>SM Name:</strong> {smname} <br />
          <strong>SM Mobile:</strong> {smmobile} <br />
          <strong>SM Email:</strong> {smemail}
        </div>
      )} */}
      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: 400,
          width: "100%",
        }}
      >
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Name
          </label>
          <input
            name="username"
            value={form.username}
            onChange={handleChange}
            className="form-control"
            required
            inputMode="text"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Mobile
          </label>
          <input
            name="mobile"
            value={form.mobile}
            onChange={handleChange}
            className="form-control"
            required
            type="tel"
            pattern="[0-9]{10}"
            maxLength={10}
            inputMode="numeric"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Loan Amount
          </label>
          <input
            name="loanamount"
            value={form.loanamount}
            onChange={handleChange}
            className="form-control"
            required
            type="number"
            min={1}
            inputMode="numeric"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Loan Type
          </label>
          <input
            name="loantype"
            value={form.loantype}
            onChange={handleChange}
            className="form-control"
            required
            placeholder="Enter loan type"
            inputMode="text"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Email (optional)
          </label>
          <input
            name="email"
            value={form.email}
            onChange={handleChange}
            className="form-control"
            type="email"
            placeholder="Enter email (optional)"
            inputMode="email"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Employment Type
          </label>
          <div>
            <label className="me-3" style={{ fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="employmentType"
                value="salaried"
                checked={form.employmentType === "salaried"}
                onChange={handleEmploymentTypeChange}
              />{" "}
              Salaried
            </label>
            <label style={{ fontSize: "0.95rem" }}>
              <input
                type="radio"
                name="employmentType"
                value="selfemployed"
                checked={form.employmentType === "selfemployed"}
                onChange={handleEmploymentTypeChange}
              />{" "}
              Self Employed
            </label>
          </div>
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Monthly Salary
          </label>
          <input
            name="monthlySalary"
            value={form.monthlySalary}
            onChange={handleChange}
            className="form-control"
            required={form.employmentType === "salaried"}
            type="number"
            min={0}
            inputMode="numeric"
            placeholder="Enter monthly salary"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <div className="mb-3">
          <label className="form-label" style={{ fontSize: "1rem" }}>
            Company Name
          </label>
          <input
            name="companyName"
            value={form.companyName}
            onChange={handleChange}
            className="form-control"
            required={form.employmentType === "salaried"}
            type="text"
            placeholder="Enter company name"
            inputMode="text"
            style={{ fontSize: "0.95rem" }}
          />
        </div>
        <button
          className="btn btn-success w-100 mb-5"
          type="submit"
          style={{ fontSize: "1rem" }}
        >
          Submit
        </button>
      </form>
      {/* Success Popup */}
      {showSuccess && (
        <div
          className="modal show fade"
          style={{
            display: "block",
            background: "rgba(0,0,0,0.5)",
            zIndex: 2000,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{
              maxWidth: 350,
              width: "95vw",
              margin: "0 auto",
            }}
          >
            <div className="modal-content" style={{ borderRadius: 10 }}>
              <div className="modal-header" style={{ padding: "0.5rem 1rem" }}>
                <h5 className="modal-title" style={{ fontSize: "1.1rem" }}></h5>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "1.1rem" }}
                  onClick={() => {
                    setShowSuccess(false);
                    window.location.href = "https://mybankshoppy.com";
                  }}
                ></button>
              </div>
              <div
                className="modal-body text-center"
                style={{ padding: "1rem" }}
              >
                <div
                  style={{
                    fontSize: "1rem",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  <span role="img" aria-label="celebrate">
                    🎉
                  </span>{" "}
                  Lead submitted successfully!
                  <br />
                  Thank you for sharing your details. Our Sales Manager will be
                  in touch with you soon.
                  <br />
                  <b>📌 Contact Information:</b>
                  <table
                    className="table table-bordered mt-2"
                    style={{
                      fontSize: "0.95rem",
                      width: "100%",
                      marginBottom: 0,
                      wordBreak: "break-word",
                    }}
                  >
                    <tbody>
                      <tr>
                        <td style={{ width: 40 }}>
                          <span role="img" aria-label="person">
                            👤
                          </span>{" "}
                        </td>
                        <td>{smname || "Sales Manager Name"}</td>
                      </tr>
                      <tr>
                        <td>
                          <span role="img" aria-label="phone">
                            📞
                          </span>{" "}
                        </td>
                        <td>{smmobile || "Sales Manager Mobile Number"}</td>
                      </tr>
                      <tr>
                        <td>
                          <span role="img" aria-label="email">
                            ✉️
                          </span>{" "}
                        </td>
                        <td>{smemail || "Sales Manager Email ID"}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div style={{ fontSize: "0.95rem", marginTop: 8 }}>
                    ⏱ Available: Mon–Sat, 9:30 AM – 7:30 PM
                    <br />
                    For quick assistance, feel free to reach out directly.
                  </div>
                </div>
                <button
                  className="btn btn-primary mt-2 w-100"
                  style={{ fontSize: "1rem" }}
                  onClick={() => {
                    setShowSuccess(false);
                    window.location.href = "https://mybankshoppy.com";
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadsFromShops;
